import { ApiErrorMessage } from 'constants/ErrorMessages';
import { useAppDispatch } from 'hooks/useAppDispatch';
import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Spin } from 'antd';

import { getPartnerAssignmentDetails } from 'redux/reducers/assignmentSlice';
import BaseAlert from 'components/wrappers/BaseAlert';
import AssignmentsPrimaryInfoSection from '../AssignmentDetailsPage/AssignmentPrimaryInfoSection';
import { AssignmentMode } from '../AssignmentDetailsPage/AssignmentPrimaryInfoSection/AssignmentsPrimaryInfoSection';
import { AssignmentInfoUserResponseModel } from 'api/backofficeApiClient';

type ParamsProps = {
  assignmentKey: string;
};

export default function PartnerAssignmentDetailsPage() {
  const { assignmentKey = '' } = useParams<ParamsProps>();
  const [isInitialLoaded, setIsInitialLoaded] = useState(false);
  const [partnerAssignmentDetails, setPartnerAssignmentDetails] =
    useState<AssignmentInfoUserResponseModel>();
  const dispatch = useAppDispatch();

  const loadPartnerAssignmentDetails = useCallback(async () => {
    const result = await dispatch(getPartnerAssignmentDetails(assignmentKey));

    if (getPartnerAssignmentDetails.fulfilled.match(result)) {
      setPartnerAssignmentDetails(result.payload);
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
    setIsInitialLoaded(true);
  }, [dispatch, assignmentKey]);

  useEffect(() => {
    loadPartnerAssignmentDetails();
    // eslint-disable-next-line
  }, []);

  if (!isInitialLoaded) return <Spin size="large" />;

  return (
    <div className="page-wrapper scroll-box">
      <div className="page-holder">
        {partnerAssignmentDetails && (
          <AssignmentsPrimaryInfoSection
            assignmentDetails={partnerAssignmentDetails}
            loadAssignmentDetails={loadPartnerAssignmentDetails}
            mode={AssignmentMode.Partner}
          />
        )}
      </div>
    </div>
  );
}
